import AddressOption from '@components/order/models/edit/AddressOption';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import AddressOptionBaseButton from './AddressOptionBaseButton';

interface AddressOptionListItemProps {
    title: string;
    icon: React.ReactNode;
    value: AddressOption;
    selectedValue: AddressOption;
    onClick: (addressOption: AddressOption) => void;
    disabled?: boolean
}

const AddressOptionListItem: React.FC<AddressOptionListItemProps> = observer(({ title, icon, value, selectedValue, onClick, disabled = false }) => {
    return (
        <AddressOptionBaseButton value={value} selectedValue={selectedValue} onClick={onClick} disabled={disabled} >
            <Box display={"flex"} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"} textAlign={"left"}>
                {icon}
                <Typography ml={1} variant='subtitle2'>{title}</Typography>
            </Box>
        </AddressOptionBaseButton>
    )
})

export default AddressOptionListItem;